module.exports = __webpack_public_path__ + "img/技术工单.f03057a8.svg";